import React, { Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import { Link } from 'react-router';

// import Error from './../blocks/errors/Error404';
import { downloadSpeaker } from './actions';
import './style.css';


class Speaker extends Component {
  _returnSpeaker = (speaker) => {
    let speakerCompany = [];
    if (speaker.speakerShortView.company.name) {
      speakerCompany.push(
        <a target='_blank' className='speaker__company' href={speaker.speakerShortView.company.url}>
          {speaker.speakerShortView.company.name}
        </a>
      );
      speakerCompany.push(', ');
    }
    return (
      <div className='speaker__info_big' key={speaker.speakerShortView.idStr}>
        <img className='speaker__photo' src={speaker.speakerShortView.pictureUrl} alt={speaker.speakerShortView.userView.fullName} />
        <div className='speaker__about'>
          <div className='speaker__name speaker__name_big simple_div'>
            {speaker.speakerShortView.userView.fullName}
          </div>
          <div className='speaker__position speaker__position_big'>
            {speakerCompany}
            {
              [
                speaker.speakerShortView.jobPosition,
                speaker.speakerShortView.userView.cityName
              ].filter(value => value).join(', ')
            }
          </div>
          <div className='speaker__selfdesc'>
            {speaker.speakerShortView.selfDescription}
          </div>
        </div>
      </div>
    )
  }

  _returnRoomEvent = (speaker) => {
    return speaker.roomEventShortViewWithTime.map(eventRoom => {

      let eventDay = eventRoom.eventDay ? eventRoom.eventDay : '';
      let startTime = eventRoom.startTime ? eventRoom.startTime : '';
      let endTime = eventRoom.endTime ? eventRoom.endTime : '';

      return (
        <div className='speaker__event' key={eventRoom.idStr}>
          <div className='speaker__event-time'>{eventDay + ' ' + startTime + '-' + endTime}</div>
          <div className='speaker__event-title'>
            <a target='_blank' className='speaker__event-link' href={eventRoom.roomEventUrl}>
              {eventRoom.title}
            </a>
          </div>
          <div className='speaker__event-desc'>{eventRoom.description}</div>
        </div>
      )
    })
  }
  componentDidMount() {
    let user = {};
    user.id = parseInt(window.location.search.split('=')[1]);
    if (user.id) {
      this.props.downloadSpeaker(user);
    }
    window.scrollTo(0, 0);
  }

  render() {
    let speaker = this.props.speakerView;
    let user;
    let roomEvent;
    if (speaker && speaker.speakerShortView) {
      user = this._returnSpeaker(speaker);
      roomEvent = this._returnRoomEvent(speaker);
    }
    return (
      <div className='speakers'>
        <div className='speakers__container'>
          {user}
          {roomEvent}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    speakerView: state.speakers.speakerView
}};

const mapDispatchToProps = (dispatch) => ({
  downloadSpeaker: bindActionCreators(downloadSpeaker, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Speaker);



// WEBPACK FOOTER //
// ./src/speakers-page/Speaker.js